import {connect} from 'react-redux';
import {Component} from 'react';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import Modal from '-/components/general/Modal';
import {authenticate} from '-/util/authenticate';
import FunnelService from '-/services/FunnelService';
import validationStyles from '-/styles/sections/validation';
import {get} from '-/util/lodash';

const styles = theme => ({
    ...validationStyles(theme)
});

class VerifyAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: '',
            formError: '',
            showErrorMsg: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.validated === 'boolean') {
            this.setState({showErrorMsg: !nextProps.validated});
        }
    }

    // How far the member got if they leave this screen without authenticating. This is
    // the only place abandonment inside the auth step is visible - a character count,
    // never the value.
    componentWillUnmount() {
        if (this.props.validated === true) {
            return;
        }

        FunnelService.authFieldProgress('account', 'account', this.state.account);
    }

    handleSubmit = () => {
        const {authenticate} = this.props;
        const {account} = this.state;
        let formError;

        if (!account) {
            formError = 'You must provide an account number before authenticating.';
            FunnelService.authFieldProgress('account', 'account', account);
        } else {
            authenticate('account', account);
        }

        this.setState({
            formError
        });
    };

    handleAccountChange = e => {
        const account = get(e, 'target.value', '');

        this.setState({
            account
        });
    };

    handleKeyDown = e => {
        if (e.keyCode === 13) {
            this.handleSubmit();
        }
    };

    render() {
        const {validated, classes = {}} = this.props;
        const {account, formError, showErrorMsg} = this.state;
        const checkClassNames = classNames(classes.verifyIcon, {
            [classes.verifyIconSuccess]: validated === true,
            [classes.verifyIconFail]: validated === false
        });
        return (
            <Modal className="verify-account" onClick={this.handleSubmit}>
                <section className={classes.description}>
                    <div className={classes.icon}>
                        <i className="fa fa-id-card" alt="ID Card" />
                        {validated !== null ? <span className={checkClassNames} /> : null}
                    </div>
                    <div className={classes.text}>
                        <h3>Verify Account Number</h3>
                        {formError && <h4 className={classes.errorText}>{formError}</h4>}
                        {showErrorMsg ? (
                            <h4 className={classes.errorText}>Your account number doesn’t match what we have on file</h4>
                        ) : null}
                    </div>
                </section>
                <div className="masked-form">
                    <div className={classes.control}>
                        <div className={classes.accountInput}>
                            <input
                                maxLength="7"
                                onChange={this.handleAccountChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="2XXXXXX"
                                value={account} />
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const {validated} = state.validationInfo;
    return {validated};
};

export default connect(mapStateToProps, {authenticate})(injectSheet(styles)(VerifyAccount));
